import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'h1[bas-headline]',
	template: '<ng-content></ng-content>',
	styleUrls: ['./h1.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class H1Component {}
